module.exports = __webpack_public_path__ + "static/media/oracle_logo.ddd23750.png";